import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useTheme,
  useMediaQuery,
  Container,
  Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link as RouterLink } from 'react-router-dom';

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const menuItems = [
    { text: 'Home', path: '/' },
    { text: 'Committee', path: '/committee' },
    { text: 'Faculty', path: '/faculty' },
    { text: 'Scientific Schedule', path: '/program' },
    { text: 'Abstract', path: '/abstract' },
    { text: 'Quiz', path: '/quiz' },
    { text: 'Registration', path: '/registration' },
    { text: 'Brochure', path: '/brochure' },
  ];

  const drawer = (
    <List>
      {menuItems.map((item) => (
        <ListItem
          button
          key={item.text}
          component={RouterLink}
          to={item.path}
          onClick={handleDrawerToggle}
        >
          <ListItemText primary={item.text} />
        </ListItem>
      ))}
    </List>
  );

  return (
    <AppBar position="static" color="default" elevation={0}>
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          py: 2 
        }}>
          {/* Images Row */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between',
            width: '100%',
            mb: 2
          }}>
            {/* Left College Logo */}
            <img
              src="/assets/logo1.png"
              alt="College Logo Left"
              style={{ height: '180px', width: 'auto' }}
            />
            
            {/* College Image */}
            <img
              src="/assets/college.jpg"
              alt="College"
              style={{ height: '180px', width: 'auto', margin: '0 20px' }}
            />
            
            {/* Right College Logo */}
            <img
              src="/assets/logo2.png"
              alt="College Logo Right"
              style={{ height: '180px', width: 'auto' }}
            />
          </Box>

          {/* Conference Title */}
          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            textAlign: 'center',
            mb: 3
          }}>
            <Typography 
              variant="h4" 
              component="h1" 
              sx={{ 
                fontWeight: 'bold',
                mb: 1
              }}
            >
              29th Annual Conference of<br />
              Association of Radiation Oncologists of India (AROI) – North Zone
            </Typography>
            
            <Typography 
              variant="h6" 
              component="h2"
              sx={{ 
                mb: 1,
                color: 'text.secondary'
              }}
            >
              1st & 2nd November 2025
            </Typography>
            
            <Typography 
              variant="h4" 
              component="h3"
              sx={{ 
                fontWeight: 'bold',
                color: 'red'
              }}
            >
              Christian Medical College and Hospital<br />
              Ludhiana, Punjab
            </Typography>
          </Box>

          {/* Navigation Menu */}
          <Toolbar sx={{ width: '100%', justifyContent: 'center' }}>
            {isMobile && (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
            )}

            {!isMobile && (
              <Box sx={{ display: 'flex', gap: 2 }}>
                {menuItems.map((item) => (
                  <Button
                    key={item.text}
                    color="inherit"
                    component={RouterLink}
                    to={item.path}
                  >
                    {item.text}
                  </Button>
                ))}
              </Box>
            )}
          </Toolbar>
        </Box>
      </Container>

      <Drawer
        variant="temporary"
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
        }}
      >
        {drawer}
      </Drawer>
    </AppBar>
  );
};

export default Header; 